import React, { useEffect, useState } from 'react'
import { follower, followerDel, following, followingDel } from '../../Api/firestoreApis';
import { useDispatch, useSelector } from 'react-redux';


function SearchPost(props) {

    const [followingt, setfollowingt] = useState(false)
    let followingData = useSelector((state) => state.Event).followingData;
    let userData = useSelector((state) => state.Event).allUserData;

    const dispatch = useDispatch();


    useEffect(() => {

        for (let i = 0; i < followingData.length; i++) {
            if (followingData[i]["obj"]["uid"] === props.hit["uid"]) {
                setfollowingt(true);
            }
        }

    }, [followingData])

    const followChanges = async (uid) => {
        let followingId = uid
        let userid = localStorage.getItem('uid');
        followingData = [...followingData, { obj: props.hit }]
        dispatch({
            type: "FOLLOWING_DATA",
            followingData: followingData,
        });

        let obj = {
            uid: props.hit["uid"],
            profilePic: props.hit["profilePic"],
            name: props.hit["name"],
            username: props.hit["username"]
        }

        let objuser = {
            uid: userid,
            profilePic: userData["profilePic"] ? userData["profilePic"] : " ",
            name: userData["firstname"] + " " + userData["lastname"],
            username: userData["username"],
        }

        await following(followingId, userid, obj)
        await follower(followingId, userid, objuser)
    }

    const UnFollow = async (uid) => {
        setfollowingt(false);
        const result = followingData.filter(checkAdult);
        function checkAdult(followingData) {
            return followingData["obj"]["uid"] != uid;
        }

        dispatch({
            type: "FOLLOWING_DATA",
            followingData: result,
        });

        setfollowingt(false);
        let followingId = uid
        let userid = localStorage.getItem('uid');
        await followingDel(followingId, userid)
        await followerDel(followingId, userid)
    }


    return (
        <div className='row post-container' style={{ color: 'white' }}>
            <div className='img-container-post'>
                <img className='profile__pic--medium' src={!props.hit["profilePic"] ? process.env.PUBLIC_URL + '/icon.jpg' : props.hit["profilePic"].url} />
                <div className='col center' style={{ textAlign: 'left', maxWidth: 100 }}>

                    <p className='notification__body--text' style={{ color: 'white', fontSize: 14, fontWeight: 500, paddingBottom: 0, lineHeight: '18px', }}>{props.hit["name"]}</p>
                    <p className='notification__body--text' style={{ color: 'white', fontSize: 14, fontWeight: 500, paddingBottom: 0, lineHeight: '18px', }}>{props.hit["username"]}</p>
                </div>
            </div>
            <div className='col center' style={{
                textAlign: 'left'
            }}>
                <button onClick={() => { followingt ? UnFollow(props.hit["uid"]) : followChanges(props.hit["uid"]) }} className='btn'>{followingt ? "UnFollow" : "Follow"}</button>
            </div>
        </div>
    )
}

export default SearchPost